import { Component, Input, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { UI } from '../../components/ui';
import { DynamicListComponent } from '@mm-aggregator/drf-dynamics';
import type { EntityConfig } from '../../config/entity-config';
import { RoleAccessService } from '../../services/role-access.service';
import { ShellRoutesService } from '../../services/shell-routes.service';

/**
 * Batch disbursements list: "New batch" link (custom create) instead of generic Add new.
 */
@Component({
  selector: 'app-batch-disbursement-list',
  standalone: true,
  imports: [DynamicListComponent, RouterLink, ...UI],
  templateUrl: './batch-disbursement-list.component.html',
})
export class BatchDisbursementListComponent {
  @Input() entityConfig!: EntityConfig;

  readonly roleAccess = inject(RoleAccessService);
  readonly shellRoutes = inject(ShellRoutesService);

  constructor(private readonly router: Router) {}

  get listPath(): string {
    return this.entityConfig?.listPath ?? '';
  }

  get title(): string {
    return this.entityConfig?.label ?? 'List';
  }

  get entityKey(): string {
    return this.entityConfig?.key ?? '';
  }

  onRowSelect(row: Record<string, unknown>): void {
    const id = row['id'] ?? row['pk'];
    if (id != null) {
      void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey, String(id)));
    }
  }
}
